import React, { useEffect, useState } from 'react';
import CustomButton from '../../../../../../../../../../../lib/designSystem/Button';
import { DialogActions, InputLabel, Select, FormControl, MenuItem, TextField, Typography } from '@mui/material';
import {
  validatePermissions,
  showAlert,
} from '../../../../../../../../../../../lib/functions/utils';
import { AuthState } from '../../../../../../../../../../../services/redux/authSlice';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import {
  getOperationsMissingConfirmingApprovals,
  approveOperationsConfirmingRequest,
  rejectOperationsConfirmingRequest,
} from '../../../../../../../../../../../lib/api/confirming';
import CenteredCircularProgress from '../../../../../../../../../../../lib/designSystem/CircularProgress';
import MissingApprovalContainer from './MissingApprovalContainer';
import ComiteeUpdateDialog from './ComiteeUpdate';
import DeleteComiteRevision from './DeleteRevision';

const ComiteeModule = (props: any) => {
  const { selectedRequest, setOpen, parentSetUp } = props;
  const dispatch = useDispatch();
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);

  const [loading, setLoading] = useState(false);
  const [approvalsRequired, setApprovalsRequired] = useState<any[]>([]);
  const [approvals, setApprovals] = useState<any[]>([]);
  const [reason, setReason] = useState('');
  const [canApprove, setCanApprove] = useState(false);
  const [comitee, setComitee] = useState<any>(null);
  const [table, setTable] = useState<any>('comitee');
  const [openComiteeUpdate, setOpenComiteeUpdate] = useState(false);
  const [openDeleteReview, setOpenDeleteReview] = useState(false);
  const [selectedUserRoleId, setSelectedUserRoleId] = useState<number | ''>('');
  const [userRoles, setUserRoles] = useState<{ name: string }[]>([]);
  const setUpMissingApprovals = async () => {
    setLoading(true);
    try {
      const { rolesToApprove, comitee, businessApprovals, approvals } = await getOperationsMissingConfirmingApprovals(
        dispatch,
        selectedRequest.id,
      );
      setComitee(comitee);
      setApprovalsRequired(rolesToApprove);
      setApprovals(approvals);
      setComitee(comitee);
      const userRolesList = Array.isArray(user?.roles) ? user.roles : [];
      const requiredRoleIds = new Set(
        rolesToApprove.filter((r: any) => !r.approved).map((r: any) => r.id),
      );
      const approvedRoleIds = new Set(
        approvals
          .filter((a: any) => a.userId === user?.id)
          .map((a: any) => a.roleId),
      );
      const userRolesWithoutApproval = userRolesList.filter(
        (userRole: any) =>
          requiredRoleIds.has(userRole.id) && !approvedRoleIds.has(userRole.id),
      );
      const canApprove =
        userRolesWithoutApproval.length > 0 &&
        rolesToApprove.some((entry: any) => entry.userCanApprove);
      setCanApprove(canApprove);
      console.log('missingApprovals', rolesToApprove);
      if (selectedRequest.status === 'Rechazada') {
        setCanApprove(false);
      }

      setUserRoles(userRolesWithoutApproval);
      if (userRolesWithoutApproval.length === 1) {
        setSelectedUserRoleId((userRolesWithoutApproval[0] as any).id);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const handleApprove = async () => {
    setLoading(true);
    try {
      const result = {
        confirmingRequestId: selectedRequest.id,
        reason: reason,
        roleId: selectedUserRoleId
      };
      await approveOperationsConfirmingRequest(dispatch, result);
      showAlert(
        dispatch,
        'success',
        'Se ha registrado tu aprobación de la operación.',
      );
      setOpen(false);
      await parentSetUp(selectedRequest.id);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const handleReject = async () => {
    setLoading(true);
    try {
      const result = {
        confirmingRequestId: selectedRequest.id,
        reason: reason,
        roleId: selectedUserRoleId
      };
      await rejectOperationsConfirmingRequest(dispatch, result);
      showAlert(
        dispatch,
        'success',
        'Se ha registrado tu rechazo de la operación.',
      );
      setOpen(false);
      await parentSetUp(selectedRequest.id);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const canEdit = selectedRequest.status === 'Aceptada';

  useEffect(() => {
    setUpMissingApprovals();
  }, []);

  if (loading) return <CenteredCircularProgress type="dialog" />;

  return (
    <div>
      <MissingApprovalContainer
        approvals={approvals}
        missingApprovals={approvalsRequired}
        comitee={comitee}
        table={table}
        setTable={setTable}
      />
      {selectedRequest.status === 'Rechazada' && (
        <Typography variant="body1" color="error" fontWeight="bold">
          Esta solicitud ha sido rechazada
        </Typography>
      )}
      {canApprove && (
        <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
          <TextField
            margin="normal"
            fullWidth
            label="Motivo"
            value={reason}
            multiline
            onChange={(e) => setReason(e.target.value)}
          />
          {userRoles && (
            <FormControl
              margin="normal"
              style={{
                minWidth: 200,
                alignSelf: 'stretch',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <InputLabel id="firmas-como-label">Firmas como</InputLabel>
              <Select
                labelId="firmas-como-label"
                id="firmas-como-select"
                value={selectedUserRoleId}
                label="Firmas como"
                onChange={(e) =>
                  setSelectedUserRoleId(e.target.value as number)
                }
              >
                {userRoles.map((role: any) => (
                  <MenuItem key={role.id} value={role.id}>
                    {role.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </div>
      )}
      <DialogActions>
        {validatePermissions(user, 'comitee_change') && canEdit && (
          <CustomButton
            onClick={() => setOpenComiteeUpdate(true)}
            color="warning"
          >
            Comité
          </CustomButton>
        )}
        {validatePermissions(user, 'comitee_delete_approval') && canEdit && (
          <CustomButton onClick={() => setOpenDeleteReview(true)} color="error">
            Borrar revisión
          </CustomButton>
        )}
        <CustomButton onClick={() => setOpen(false)} color="secondary">
          Cerrar
        </CustomButton>
        <CustomButton
          onClick={handleReject}
          color="error"
          variant="contained"
          disabled={!canApprove}
        >
          Rechazar
        </CustomButton>
        <CustomButton
          onClick={handleApprove}
          color="success"
          variant="contained"
          disabled={!canApprove}
        >
          Aprobar
        </CustomButton>
      </DialogActions>
      {openComiteeUpdate && (
        <ComiteeUpdateDialog
          selectedRequest={selectedRequest}
          open={openComiteeUpdate}
          setOpen={setOpenComiteeUpdate}
          setUp={setUpMissingApprovals}
          comitee={comitee}
        />
      )}
      {openDeleteReview && (
        <DeleteComiteRevision
          selectedRequest={selectedRequest}
          open={openDeleteReview}
          setOpen={setOpenDeleteReview}
          setUp={setUpMissingApprovals}
        />
      )}
    </div>
  );
};

export default ComiteeModule;
